import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import { motion } from "framer-motion";

const stats = [
    { value: "98%", label: "Satisfaction Rate" },
    { value: "24hrs", label: "Avg. Time to Match" },
    { value: "10K+", label: "Placements Made" },
    { value: "150+", label: "Cities Covered" },
];

const ImpactStats = () => {
    return (
        <Box
            sx={{
                py: { xs: 8, md: 12 },
                background: "linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%)",
                fontFamily: "'Poppins', sans-serif",
                color: "#0B1121",
                textAlign: "center",
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={6} justifyContent="center" alignItems="center">
                    {stats.map((stat, index) => (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                viewport={{ once: true }}
                            >
                                <Typography
                                    variant="h2"
                                    sx={{
                                        fontWeight: 700,
                                        fontSize: { xs: "40px", md: "56px" },
                                        color: "#FF6B00", // Brand Orange
                                        mb: 1,
                                        fontFamily: "'Poppins', sans-serif",
                                        lineHeight: 1,
                                    }}
                                >
                                    {stat.value}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: "16px",
                                        fontWeight: 500,
                                        color: "#64748B", // Slate Grey
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                >
                                    {stat.label}
                                </Typography>
                            </motion.div>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default ImpactStats;
